import { filterMaybe } from '@edge/spark/utils'
import { useActAsUsersQuery } from '../generated/graphql'
import { useActiveAuctionId } from '../activeAuctionIdStore'
import { useIsAdmin } from './useIsAdmin'

/** If an admin, returns list of users available to act as */
export const useActAsUsersList = (props?: { skip?: boolean }) => {
    const { skip } = props || {}
    const auctionId = useActiveAuctionId()
    const isAdmin = useIsAdmin()
    const { data } = useActAsUsersQuery({ variables: { auctionId }, skip: !isAdmin || skip })
    if (skip || !isAdmin) return []
    const users = data?.administrator?.users || []
    return users.filter(filterMaybe)
}
